<div class="page-header">
  <div>
    <h1>Gestão de Equipamentos</h1>
    <p>Viaturas · Armas · Utensílios — Rastreio completo de ativos</p>
  </div>
  <div class="page-actions">
    <button class="btn-web-secondary" (click)="showFiltersDrawer = true">
      <i class="ri-filter-3-line"></i> Filtros
      <span class="filter-badge" *ngIf="activeFilterCount > 0" style="
          background: var(--sp-primary);
          color: white;
          border-radius: 50%;
          padding: 2px 6px;
          font-size: 11px;
          margin-left: 4px;
        ">{{ activeFilterCount }}</span>
    </button>
    <button class="btn-web-secondary" disabled pTooltip="Funcionalidade futura" tooltipPosition="bottom">
      <i class="fas fa-chart-bar"></i> Inventário por Posto
    </button>
    <button class="btn-web-secondary" disabled pTooltip="Funcionalidade futura" tooltipPosition="bottom">
      <i class="fas fa-file-export"></i> Exportar Relatório
    </button>
  </div>
</div>

<app-equipamento-filter-drawer 
  *ngIf="showFiltersDrawer" 
  [visible]="showFiltersDrawer" 
  (close)="showFiltersDrawer = false"
  (applyFilter)="onApplyFilter($event)"/>

<div class="subtab-bar">
  <a class="subtab-btn" routerLink="/admin/equipamentos/viaturas" routerLinkActive="active">
    <i class="fas fa-car"></i> Viaturas
    <span class="subtab-badge" *ngIf="!loadingCounts">{{ totalViaturas }}</span>
  </a>
  <a class="subtab-btn" routerLink="/admin/equipamentos/armas" routerLinkActive="active">
    <i class="fas fa-shield-halved"></i> Armas
    <span class="subtab-badge red" *ngIf="!loadingCounts">{{
      totalArmas
      }}</span>
  </a>
  <a class="subtab-btn" routerLink="/admin/equipamentos/utensilios" routerLinkActive="active">
    <i class="fas fa-toolbox"></i> Utensílios
    <span class="subtab-badge" *ngIf="!loadingCounts">{{
      totalUtensilios
      }}</span>
  </a>
  <a *ngIf="false" class="subtab-btn" routerLink="/admin/equipamentos/tipos" routerLinkActive="active">
    <i class="fas fa-sliders"></i> Configuração
  </a>
</div>
